import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-broadcast",
  "use": "icon-nav-broadcast-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-nav-broadcast\"><path d=\"M3 11v2a9 9 0 009 9h1\" /><path d=\"M12 3a9 9 0 019 9\" /><path d=\"M8 15v.01\" /><path d=\"M11 12a3 3 0 00-3 3\" /><path d=\"M14 9a6 6 0 00-6 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/nav-broadcast.svg
// module id = l8Co
// module chunks = 24